<div class="amway-main-layout step-creator">
    <div class="amway-main-layout__content ">
        <div class="amway-shop-content-area">
            <div class="section-400">
                <div class="lottie-player-holder"
                    id="lottieHolder"
                    #lottieHolder></div>
                <div class="content">
                    <h2>ขออภัย<br class="hidden-md hidden-lg"> หน้านี้ไม่สามารถใช้งานได้แล้ว</h2>
                    <div class="place-btn">
                        <button class="btn-black-white"
                            aria-label="navigate to shop home"
                            (click)="navigateShopHome()">
                            กลับสู่หน้าหลัก
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
